import { createFileRoute } from '@tanstack/react-router'

import { PlatformTroubleshootingSessionPage } from '../../../../../components/pages/backoffice/platform/platform-troubleshooting-session.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/troubleshooting/sessions/$sessionId')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformTroubleshootingSessionPage />
    </PermissionChecker>
  ),
})
